import { render, staticRenderFns } from "./ChatUserCard.vue?vue&type=template&id=cfde2160&scoped=true"
import script from "./ChatUserCard.vue?vue&type=script&lang=js"
export * from "./ChatUserCard.vue?vue&type=script&lang=js"
import style0 from "./ChatUserCard.vue?vue&type=style&index=0&id=cfde2160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde2160",
  null
  
)

export default component.exports